import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import { } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';  // To handle routing and fetching the project by ID
import { API_BASE_URL } from '../../api';
import Sidebar from './Sidebar'
import Header from './Navbar'
import Footer from './Footer'
import Loader from './Loader';
import axios from 'axios';
import Select from 'react-select';
import { priceInWords } from '../../Helpers'
// import { convertToWords } from 'react-number-to-words';

const Add_Project_ledger = () => {

    const navigate = useNavigate();

    const { project_id } = useParams();
    const { client_id } = useParams();
    const { parent_id } = useParams();

    const [creditInWord, setCreditInWord] = useState([]);
    const [debitInWord, setDebitInWord] = useState([]);
    const [nongstInWord, setNongstInWord] = useState([]);
    const [gstamountInWord, setGstamountInWord] = useState([]);
    const [projects, setProjects] = useState([]); // Array to store all projects
    const [clients, setClients] = useState([]);
    const [parentLedger, setParentLedger] = useState([]);
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        user_id: localStorage.getItem('userId'),
    };

    const [formData, setFormData] = useState({
        client_id: (client_id ? parseInt(client_id) : ""),
        project_id: (project_id ? parseInt(project_id) : ""),
        parent_id: (parent_id ? parseInt(parent_id) : ""),
        firm: "SAI LLP",
        title: "",
        date: "",
        start_date: "",
        end_date: "",
        renewal_month: "",
        retainer: 0,
        debit: 0,
        credit: 0,
        nongst: 0,
        gstamount: 0,
    });

    // Fetch all projects to populate dropdown
    const fetchProjects = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/project`, { headers });
            setProjects(response.data);
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };
    const fetchClients = async () => {
        try {
            const { data } = await axios.get(`${API_BASE_URL}/api/client`, { headers });
            setClients(data);
        } catch (error) {
            console.error('Error fetching clients:', error.response?.data || error.message);
        }
    };
    const fetchLedger = async () => {
        try {
            const { data } = await axios.get(`${API_BASE_URL}/api/ledger/parent`, { headers });
            setParentLedger(data);
        } catch (error) {
            console.error('Error fetching ledger:', error.response?.data || error.message);
        }
    };

    useEffect(() => {
        fetchClients();
        fetchProjects();
        fetchLedger();
    }, []); // Fetch projects on mount

    useEffect(() => {
        if (formData.parent_id != null && formData.parent_id != "") {
            document.getElementsByClassName('paymentHide1')[0].style.display = 'none';
            document.getElementsByClassName('paymentHide2')[0].style.display = 'none';
            document.getElementsByClassName('paymentHide3')[0].style.display = 'none';
            document.getElementsByClassName('paymentHide4')[0].style.display = 'none';
            document.getElementsByClassName('paymentHide5')[0].style.display = 'none';
            document.getElementsByClassName('paymentHide6')[0].style.display = 'none';
        } else {
            document.getElementsByClassName('paymentHide1')[0].style.display = 'block';
            document.getElementsByClassName('paymentHide2')[0].style.display = 'block';
            document.getElementsByClassName('paymentHide3')[0].style.display = 'block';
            document.getElementsByClassName('paymentHide4')[0].style.display = 'block';
            document.getElementsByClassName('paymentHide5')[0].style.display = 'block';
            document.getElementsByClassName('paymentHide6')[0].style.display = 'block';
        }
    }, [formData]); // Fetch projects on mount

    const projectOptions = useMemo(
        () =>
            projects.map((project) => ({
                value: project.id,
                label: project.project_name,
            })),
        [projects]
    );

    const clientOptions = useMemo(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.full_name,
            })),
        [clients]
    );

    const ledgerOptions = useMemo(
        () =>
            parentLedger.map((ledger) => ({
                value: ledger.id,
                label: ledger.id + ' - ' + ledger.title + ' - ' + ledger.client.full_name,
            })),
        [parentLedger]
    );
    // console.log(clientOptions)

    // // Create selected option object for the project select
    // const handleProjectChange = projectOptions.find(
    //     (option) => option.value === formData.project_id
    // ) || null;

    // console.log(clientOptions);
    // // Create selected option object for the client select
    // const handleClientChange = clientOptions.find(
    //     (option) => option.value === formData.client_id
    // ) || null;


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };


    // Handler for standard input fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const numberChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if (name == 'credit') {
            setCreditInWord(priceInWords(value));
        }
        if (name == 'debit') {
            setDebitInWord(priceInWords(value));
        }
        if (name == 'nongst') {
            setNongstInWord(priceInWords(value));
        }
        if (name == 'debgstamountit') {
            setGstamountInWord(priceInWords(value));
        }
        // amountinword.html()
    };

    // Create selected option object for the client select
    const selectedClientOption = clientOptions.find(
        (option) => option.value === formData.client_id
    ) || null;


    // Handler for react-select components
    const handleSelectChange = (selectedOption, actionMeta) => {
        console.log(selectedOption);
        // //console.log(actionMeta);
        setFormData((prevData) => ({
            ...prevData,
            [actionMeta.name]: selectedOption ? selectedOption.value : '',
        }));
        //console.log(formData[actionMeta.name]);
        //console.log(actionMeta.name);
        //console.log(formData);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const { data } = await axios.post(
                `${API_BASE_URL}/api/ledger`,
                formData,
                { headers }
            );

            Swal.fire({
                icon: 'success',
                title: 'Project Ledger Stored',
                text: 'The project ledger has been stored successfully!',
            });
            navigate(`/dashboard/view-project/${data.data.project_id}`);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Failed to store project ledger: ${error.response?.data?.message || error.message}`,
            });
        }
    };


    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />
            <main id='main' className='main'>
                <section className='section'>
                    <div className='row'>
                        <div className="col-12">
                            <div className="">
                                <Loader />
                                <div className="content">
                                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                                        <div className="my-auto mb-2 text-start">
                                            <div className="pagetitle">
                                                <h1>Project Ledger</h1>
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li className="breadcrumb-item">
                                                            <a href="#">Home</a>
                                                        </li>
                                                        <li className="breadcrumb-item active">Project Ledger</li>
                                                    </ol>
                                                </nav>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="card text-start">
                                        <div className="card-body">
                                            <div className="">

                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">

                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Client</label>
                                                            <Select
                                                                options={clientOptions}
                                                                name="client_id"
                                                                value={clientOptions.find((option) => option.value === formData.client_id)}
                                                                // onChange={handleClientChange}
                                                                onChange={handleSelectChange}
                                                                placeholder="Select a Client"
                                                                isClearable
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Project Name</label>
                                                            <Select
                                                                options={projectOptions}
                                                                name="project_id"
                                                                value={projectOptions.find((option) => option.value === formData.project_id)}
                                                                // onChange={handleProjectChange}
                                                                onChange={handleSelectChange}
                                                                placeholder="Select a Project"
                                                                isClearable
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Old Ledger</label>
                                                            <Select
                                                                options={ledgerOptions}
                                                                name="parent_id"
                                                                value={ledgerOptions.find((option) => option.value === formData.parent_id)}
                                                                // onChange={handleClientChange}
                                                                onChange={handleSelectChange}
                                                                placeholder="Select a Ledger"
                                                                isClearable
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3 paymentHide6">
                                                            <label className="form-label">Retainer</label>
                                                            <select
                                                                name="retainer"
                                                                value={formData.retainer}
                                                                onChange={(e) => setFormData({ ...formData, retainer: e.target.value })}
                                                                className="form-select"
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="0">No</option>
                                                                <option value="1">Yes</option>
                                                            </select>
                                                        </div>
                                                        <div className='clearfix'></div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">FIRM</label>
                                                            <select
                                                                name="firm"
                                                                value={formData.firm}
                                                                onChange={(e) => setFormData({ ...formData, firm: e.target.value })}
                                                                className="form-select"
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="BHAVIK">BHAVIK</option>
                                                                <option value="BRIJESH">BRIJESH</option>
                                                                <option value="CK_JAYDEEP">CK_JAYDEEP</option>
                                                                <option value="SAI LLP">SAI LLP</option>
                                                                <option value="SAI OLD">SAI OLD</option>
                                                                <option value="REALDO">REALDO</option>
                                                                <option value="MEGHA">MEGHA</option>
                                                                <option value="CASH">CASH</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Title</label>
                                                            <input
                                                                type="text"
                                                                name="title"
                                                                value={formData.title}
                                                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Date</label>
                                                            <input
                                                                type="date"
                                                                name="date"
                                                                value={formData.date}
                                                                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3 paymentHide6">
                                                            <label className="form-label">Renewal Month</label>
                                                            <select
                                                                name="renewal_month"
                                                                value={formData.renewal_month}
                                                                onChange={(e) => setFormData({ ...formData, renewal_month: e.target.value })}
                                                                className="form-select"
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="6">6</option>
                                                                <option value="12">12</option>
                                                                <option value="18">18</option>
                                                                <option value="24">24</option>
                                                                <option value="30">30</option>
                                                                <option value="36">36</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-6 mb-3 paymentHide1">
                                                            <label className="form-label">Start Date</label>
                                                            <input
                                                                type="date"
                                                                name="start_date"
                                                                value={formData.start_date}
                                                                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3 paymentHide2">
                                                            <label className="form-label">End Date</label>
                                                            <input
                                                                type="date"
                                                                name="end_date"
                                                                value={formData.end_date}
                                                                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="col-6 mb-3 paymentHide3">
                                                            <label className="form-label">Subtotal With out GST</label>
                                                            <input
                                                                type="number"
                                                                name="nongst"
                                                                value={formData.nongst}
                                                                onChange={numberChange}
                                                                className="form-control"
                                                                required
                                                            />
                                                            <span id="nongstinword">{nongstInWord}</span>
                                                        </div>
                                                        <div className="col-6 mb-3 paymentHide4">
                                                            <label className="form-label">Total with GST</label>
                                                            <input
                                                                type="number"
                                                                name="gstamount"
                                                                value={formData.gstamount}
                                                                onChange={numberChange}
                                                                className="form-control"
                                                                required
                                                            />
                                                            <span id="gstamountinword">{gstamountInWord}</span>
                                                        </div>
                                                        <div className="col-6 mb-3 paymentHide5">
                                                            <label className="form-label">Debit</label>
                                                            <input
                                                                type="number"
                                                                name="debit"
                                                                value={formData.debit}
                                                                onChange={numberChange}
                                                                className="form-control"
                                                                required
                                                            />
                                                            <span id="debitinword">{debitInWord}</span>
                                                        </div>
                                                        <div className="col-6 mb-3">
                                                            <label className="form-label">Credit</label>
                                                            <input
                                                                type="number"
                                                                name="credit"
                                                                value={formData.credit}
                                                                onChange={numberChange}
                                                                className="form-control"
                                                                required
                                                            />
                                                            <span id="creditinword">{creditInWord}</span>
                                                        </div>
                                                        {/* parent_id */}
                                                    </div>

                                                    <div className="d-flex justify-content-end">
                                                        <button type="button" className="btn btn-outline-light border me-2" onClick={() => navigate('/dashboard/project')}>Cancel</button>
                                                        <button type="submit" className="btn btn-primary">Save</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default Add_Project_ledger
